//src/rtkQuery/config/ordersApi.config.ts

export const ORDERS_ENDPOINTS = {
  GET_ORDERS_FOR_PATIENT: '/orders/ordersForPatient',
  POST_CANCEL_ORDER: '/orders/cancelOrder',
} as const;